












import { defineComponent, ref } from "@vue/composition-api";
import saveFile from "@/lib/saveFileHelper";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "BaseDownloadButton",
  components: { BaseIconButton },
  props: {
    fontSize: { type: [String, Number], default: 24 },
    color: { type: String, default: "var(--palette-bg)" },
    url: { type: String, default: "" },
    name: { type: String, default: "file" },
    fullscreen: { type: Boolean, default: false },
  },
  setup(props) {
    const loading = ref(false);

    const createSaveUrl = async () => {
      const response = await fetch(props.url);
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    };

    const handleClick = async () => {
      try {
        loading.value = true;
        const url = await createSaveUrl();
        saveFile({ href: url, name: props.name });
      } finally {
        loading.value = false;
      }
    };

    return { loading, handleClick };
  },
});
